import React, { useEffect, Fragment, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Breadcrumbs from 'CommonElements/Breadcrumbs';
import ProductForm from 'Component/DashboardQeza/Product/Form';
import { getProduct } from 'Services/Features/Product/Utils/productUtils';
import { setFormData, resetFormData } from 'Services/Features/Product/productSlice';

const TreatmentAdd = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const filters = useSelector(state => state.product.filters)
    const currentProduct = useSelector((state) => state.product.currentProduct);
    const [refetch, setRefetch] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        if (id) {
            // Buat filter untuk ambil data berdasarkan ID
            const newFilters = {
                ...filters,
                "filter[id]": id,
                page: 1,
            };

            // Fetch data dari API pakai ID
            dispatch(getProduct(newFilters)).then((response) => {
                if (response.payload && response.payload.data?.length > 0) {
                    const item = response.payload.data[0]; // Ambil item pertama (kalau ada)

                    // Simpan photo & banner ke state terpisah
                    dispatch(setFormData({ photoLink: item.photo }));

                    // Buat objek baru tanpa photo & banner
                    const { photo, ...updatedItem } = item;

                    dispatch(setFormData({
                        ...updatedItem,
                        category_id: item.category?.id,
                    }));
                }
            });
        } else if (currentProduct?.id) {
            // Kalau nggak ada ID, tapi ada data di state, pakai yang ada
            dispatch(setFormData({
                ...currentProduct,
            }));
        } else {
            // Kalau nggak ada ID & data di state, reset form
            dispatch(resetFormData());
        }
    }, [id, refetch]);



    return (
        <Fragment>
            <Breadcrumbs parent="Produk" title={id ? 'Edit Produk' : 'Tambah Produk'} />
            <ProductForm label={id ? "" : "Produk Baru"} setRefetch={setRefetch} />
        </Fragment>
    );
};
export default TreatmentAdd;